import APContactSectionClosed from "./APContactSectionClosed";

export { APContactSectionClosed };

export default APContactSectionClosed;
